import {importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {AppComponent} from './app/app.component';
import {BrowserModule, bootstrapApplication} from '@angular/platform-browser';
import {provideRouter, withComponentInputBinding} from '@angular/router';
import {provideAnimations} from '@angular/platform-browser/animations';
import {NgEventBus} from 'ng-event-bus';
import {routes} from './app/app.routes';
import {JwtInterceptor} from './app/common/service/jwt.interceptor';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {OverlayContainer} from '@angular/cdk/overlay';
import {NlrOverlayContainer} from './app/common/cdk/overlay/nlr-overlay-container';
import './zone-flags';
import 'zone.js';

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(routes, withComponentInputBinding()),
        {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
        importProvidersFrom(BrowserModule),
        NgEventBus,
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        {provide: OverlayContainer, useClass: NlrOverlayContainer}
    ]
}).catch(err => console.error(err));
